import { GfsCalculationEditor } from "@/services/backend/gfs/calculation/components/calculation-editor";

export default function GfsCalculationRoute() {
  return <GfsCalculationEditor />;
}
